
export const getAPIUrl = () => {
  return (window as any).env?.API_URL || process.env.REACT_APP_API_UR;
};

export const getDefaultLang = () => {
  return (window as any).env?.DEFAULT_LANG || process.env.REACT_APP_DEFAULT_LANG;
};